/* ================================================================
   LILIMAUS Empfehlungs-Engine (CRO Welle 3, Stand 2026-09-10)
   ----------------------------------------------------------------
   Fuellt zwei Container mit "Passt perfekt dazu"-Karten
   (Bild links, Titel/Farbe/Preis inkl. MwSt., runder Plus-Button —
   Layout-Vorlage: Marc-Screenshot 07.07.):

   1) [data-lm-cross-sell]      im Warenkorb-Drawer (Kontextfarben =
                                Farben der Warenkorb-Artikel)
   2) [data-lm-complementary]   auf der PDP (Kontextfarbe = aktuell
                                gewaehlte Variante, via data-color)

   Datenquelle: /recommendations/products.json intent=complementary
   (gepflegt aus der Ko-Kauf-Analyse; Fallback intent=related).

   HARTE FARB-REGEL (Marc 07.07.): Hat ein empfohlenes Produkt eine
   Farboption, aber KEINE verfuegbare Variante in einer Kontextfarbe
   (Kombi-Farben wie "Eukalyptus & Hellbeige" zaehlen als Treffer, beim
   empfohlenen Produkt wie bei der Kontextfarbe),
   wird es komplett ausgeblendet — kein Farb-Fallback. Produkte ohne
   Farboption (z. B. Leuchtsterne) bleiben zugelassen.

   Drawer + PDP-Section werden bei Aenderungen server-seitig neu
   gerendert (innerHTML-Replace) -> Body-MutationObserver findet
   frische, noch nicht hydratisierte Container und fuellt sie neu
   (so folgt die PDP-Empfehlung auch dem Farbwechsel der Variante).
   ================================================================ */
(function () {
  'use strict';

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }

  /* ---------------- Empfehlungen ---------------- */

  /* Vorbestell-Varianten NICHT empfehlen (Marc 2026-09-10). Befund: Der Plus-
     Button legte Vorbestell-Varianten ohne Hinweis und ohne Checkout-Merkmal
     "Vorbestellung" in den Warenkorb (43 Bestellungen im WMS ohne Kennzeichnung).
     Das oeffentliche Varianten-JSON kennt Policy/Bestand nicht; deshalb liefert
     sections/lm-preorder-ids.liquid je Produkt die Vorbestell-IDs serverseitig
     (Regel wie snippets/product-variant-picker.liquid). Diese Varianten gelten
     hier als nicht verfuegbar -> Farbregel/pickVariant blenden sie aus.
     Fail-open: ohne Antwort bleibt das bisherige Verhalten. */
  var preorderCache = {};
  function preorderIdsFor(handle) {
    if (!handle) return Promise.resolve([]);
    if (!preorderCache[handle]) {
      preorderCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '?section_id=lm-preorder-ids')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html.match(/data-lm-preorder-ids="([^"]*)"/);
          return m ? m[1].split(',').filter(Boolean) : [];
        })
        .catch(function () { return []; });
    }
    return preorderCache[handle];
  }
  function ohneVorbestellVarianten(products) {
    return Promise.all((products || []).map(function (p) {
      return preorderIdsFor(p.handle).then(function (ids) {
        if (ids.length) {
          (p.variants || []).forEach(function (v) {
            if (ids.indexOf(String(v.id)) !== -1) v.available = false;
          });
        }
        return p;
      });
    }));
  }

  function fetchRecommendations(productId) {
    var base = '/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=10';
    return fetch(base + '&intent=complementary')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        if (d.products && d.products.length) return d.products;
        return fetch(base + '&intent=related')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .then(function (d2) { return d2.products || []; });
      })
      .then(ohneVorbestellVarianten)
      .catch(function () { return []; });
  }

  function colorOptionIndex(product) {
    var idx = -1;
    (product.options || []).forEach(function (o, i) {
      var name = typeof o === 'string' ? o : (o && o.name);
      if (name && name.toLowerCase() === 'farbe') idx = i;
    });
    return idx;
  }

  function normColor(s) {
    return (s || '').toLowerCase().trim();
  }

  // Kombi-Farben ("Eukalyptus & Hellbeige") passen zur Einzelfarbe "Eukalyptus" —
  // in beide Richtungen: Kombi bei der Empfehlung ODER im Kontext (Warenkorb/PDP,
  // z. B. Wimpelkette in Kombi-Farbe; bis 24.10.26 fand die nie eine Empfehlung).
  // Rang: 4 = exakt, 3 = gleiche erste Farbe, 2 = Hauptfarbe des Kontexts steckt in
  // der Variante, 1 = Hauptfarbe der Variante steckt im Kontext. Teilen zwei Kombis
  // nur Nebenfarben -> 0 (kein Treffer, wie bisher).
  // Bei Einzelfarbe im Kontext ist das die alte Skala 3/2/1, nur um 1 verschoben.
  function colorParts(s) {
    return s.split('&').map(function (x) { return x.trim(); }).filter(Boolean);
  }
  function colorMatchRank(variantColor, contextColor) {
    var v = normColor(variantColor);
    var c = normColor(contextColor);
    if (!v || !c) return 0;
    if (v === c) return 4;
    var vp = colorParts(v), cp = colorParts(c);
    if (vp.length < 2 && cp.length < 2) return 0;
    if (vp[0] === cp[0]) return 3;
    if (vp.indexOf(cp[0]) !== -1) return 2;
    if (cp.indexOf(vp[0]) !== -1) return 1;
    return 0;
  }

  // Strikt: Produkt mit Farboption + Kontextfarben vorhanden -> nur bei Match,
  // sonst null (Produkt wird nicht angezeigt). Ohne Farboption/Kontextfarben:
  // erste verfuegbare Variante.
  function pickVariant(product, contextColors) {
    var idx = colorOptionIndex(product);
    if (idx >= 0 && contextColors.length) {
      var best = null, bestScore = 0;
      (product.variants || []).forEach(function (v) {
        if (!v.available) return;
        for (var c = 0; c < contextColors.length; c++) {
          var rank = colorMatchRank(v['option' + (idx + 1)], contextColors[c]);
          var score = rank * 10 - c;
          if (rank > 0 && score > bestScore) {
            bestScore = score;
            best = { variant: v, color: v['option' + (idx + 1)] };
          }
        }
      });
      return best; // null = keine passende Farbe -> ausblenden
    }
    var first = (product.variants || []).find(function (v) { return v.available; });
    return first ? { variant: first, color: null } : null;
  }

  function imageUrl(product, variant) {
    var src = (variant.featured_image && variant.featured_image.src) || product.featured_image || '';
    if (!src) return '';
    return src.indexOf('?') === -1 ? src + '?width=160' : src + '&width=160';
  }

  // note: optionale Zusatzzeile der Drawer-Karte (Versandschwelle, siehe hydrateCrossSell)
  // pct: Aktionsrabatt in %, der mit dem Code im Warenkorb greift (Halloween, Marc 28.10.)
  function cardHtml(product, pick, compact, note, pct) {
    var v = pick.variant;
    // Sparsets (Platzhalter-Produkt mit EINER Default-Variante ohne SKU) duerfen nie
    // direkt in den Warenkorb: nur der Set-Builder auf der Set-Seite legt die
    // Komponenten-SKUs ab. Fall #16045 (21.08.26): "+" auf der Baldachin-PDP legte
    // den Platzhalter "Kuschelecke" ohne Farbe/SKU in den Korb -> nicht lieferbar.
    // Karte bleibt (Ansage Marc 30.07.: Sets auf der PDP erlaubt), Knopf wird Link.
    var isSet = isSparsetProduct(product);
    var setUrl = product.url || ('/products/' + product.handle);
    function actionHtml(size, font, lineH) {
      var base = 'width:' + size + 'px;height:' + size + 'px;border-radius:50%;background:#111;color:#fff;border:none;' +
        'font-size:' + font + 'px;line-height:' + lineH + 'px;text-align:center;padding:0;cursor:pointer;flex-shrink:0;';
      if (isSet) {
        return '<a href="' + escapeHtml(setUrl) + '" aria-label="' + escapeHtml(product.title) + ' ansehen und Farben wählen" ' +
          'style="' + base + 'display:inline-block;text-decoration:none;">&rarr;</a>';
      }
      return '<button type="button" data-lm-add="' + v.id + '" aria-label="' + escapeHtml(product.title) + ' in den Warenkorb" ' +
        'style="' + base + '">+</button>';
    }
    // Sets: keine Preisangabe auf der Karte (Set-Preis entsteht erst aus der Farb-/
    // Optionswahl im Builder; der Platzhalter-Preis ist keine belastbare "ab"-Angabe).
    var subline = isSet ? 'Set · Farben frei wählbar · Preis auf der Set-Seite' : pick.color;
    if (compact) {
      // Schlanke Karte fuer den Warenkorb-Drawer: 1 Zeile Titel, Farbe+Preis
      // kombiniert, kleineres Bild/Button -> mehr Platz fuer die Warenkorb-Artikel.
      var priceHtml = pct > 0
        ? '<s style="color:#999;">' + money(v.price) + '</s> <span style="color:#c0392b;font-weight:700;">' + money(Math.round(v.price * (100 - pct) / 100)) + '</span>'
        : '<span style="color:#111;font-weight:600;">' + money(v.price) + '</span>';
      return (
        '<div style="display:flex;align-items:center;gap:10px;background:#fff;border:1px solid #ececec;border-radius:10px;padding:6px 8px;">' +
          '<img src="' + escapeHtml(imageUrl(product, v)) + '" alt="" loading="lazy" width="44" height="44" style="width:44px;height:44px;object-fit:cover;border-radius:6px;flex-shrink:0;">' +
          '<div style="flex:1;min-width:0;">' +
            '<div style="font-size:12px;font-weight:600;line-height:1.25;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(product.title) + '</div>' +
            (isSet
              ? '<div style="font-size:11px;color:#888;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(subline) + '</div>'
              // Farbe wird gekuerzt, nie der Preis (Streichpreis + Aktionspreis sind lang)
              : '<div style="display:flex;gap:4px;font-size:11px;color:#888;margin-top:1px;white-space:nowrap;">' +
                  (subline ? '<span style="min-width:0;overflow:hidden;text-overflow:ellipsis;">' + escapeHtml(subline) + '</span><span>·</span>' : '') +
                  '<span style="flex-shrink:0;">' + priceHtml + '</span></div>') +
            (note ? '<div data-lm-gap-note style="font-size:11px;color:#2f7a45;font-weight:600;margin-top:1px;">' + escapeHtml(note) + '</div>' : '') +
          '</div>' +
          actionHtml(32, 18, 30) +
        '</div>'
      );
    }
    return (
      '<div style="display:flex;align-items:center;gap:12px;background:#fff;border:1px solid #ececec;border-radius:12px;padding:10px 12px;">' +
        '<img src="' + escapeHtml(imageUrl(product, v)) + '" alt="" loading="lazy" width="72" height="72" style="width:72px;height:72px;object-fit:cover;border-radius:8px;flex-shrink:0;">' +
        '<div style="flex:1;min-width:0;">' +
          '<div style="font-size:13px;font-weight:600;line-height:1.35;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;">' + escapeHtml(product.title) + '</div>' +
          (subline ? '<div style="font-size:12px;color:#888;margin-top:1px;">' + escapeHtml(subline) + '</div>' : '') +
          (isSet ? '' : '<div style="margin-top:3px;"><span style="font-size:14px;font-weight:700;">' + money(v.price) + '</span>' +
          ' <span style="font-size:11px;color:#999;">inkl. MwSt.</span></div>') +
        '</div>' +
        actionHtml(40, 22, 38) +
      '</div>'
    );
  }

  // Sparsets/Set-Konfigurator gehoeren NICHT in den Warenkorb-Upsell (Ansage Marc
  // 30.07.26): wer schon Einzelteile im Korb hat, soll dort kein konkurrierendes
  // Komplett-Set angeboten bekommen. Auf der PDP bleiben sie erlaubt.
  // Erkennung ueber den Handle — /recommendations/products.json liefert weder
  // template_suffix noch (bei LILIMAUS) belastbare Tags/Types mit.
  function isSparsetProduct(product) {
    var handle = (product && product.handle) || '';
    return handle.indexOf('sparset-') === 0 || handle === 'erstelle-dein-set';
  }

  function buildCards(products, contextColors, excludeIds, limit, compact) {
    var cards = [];
    for (var i = 0; i < products.length && cards.length < limit; i++) {
      var p = products[i];
      if (!p.available || excludeIds.indexOf(String(p.id)) !== -1) continue;
      var pick = pickVariant(p, contextColors);
      if (!pick) continue;
      cards.push(cardHtml(p, pick, compact));
    }
    return cards;
  }

  /* ---------------- Drawer-Container ---------------- */

  // Versandschwelle (Marc 23.10.26): Lückenfüller und "Passt perfekt dazu" sind EINE Liste.
  // snippets/lm-versand-lueckenfueller.liquid liefert die Lücke (Cent, nur DE/AT) und
  // Kandidaten. Karten ab Lückenbetrag stehen vorn und tragen GAP_NOTE. Schließt keine
  // Empfehlung die Lücke, rückt der erste farblich passende Kandidat auf Platz 1.
  var GAP_NOTE = 'Damit ist dein Versand kostenlos';

  function readGap() {
    var el = document.querySelector('[data-lm-gap]');
    var gap = el ? Number(el.dataset.lmGap) || 0 : 0;
    if (gap <= 0) return null;
    return {
      gap: gap,
      max: Number(el.dataset.lmGapMax) || 0,
      handles: (el.dataset.lmGapHandles || '').split(',').filter(Boolean)
    };
  }

  function drawerPicks(products, contextColors, excludeIds) {
    var out = [];
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!p.available || excludeIds.indexOf(String(p.id)) !== -1) continue;
      var pick = pickVariant(p, contextColors);
      if (pick) out.push({ product: p, pick: pick });
    }
    return out;
  }

  // Erster Kandidat mit farblich passender Variante im Preisfenster [Lücke, Lücke + 30 €]
  function fetchGapFiller(gapInfo, contextColors, excludeIds) {
    return Promise.all(gapInfo.handles.slice(0, 4).map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }))
      .then(function (list) { return ohneVorbestellVarianten(list.filter(Boolean)); })
      .then(function (list) {
        for (var i = 0; i < list.length; i++) {
          var p = list[i];
          if (!p.available || isSparsetProduct(p) || excludeIds.indexOf(String(p.id)) !== -1) continue;
          var inWindow = Object.assign({}, p, {
            variants: (p.variants || []).map(function (v) {
              var ok = v.price >= gapInfo.gap && (!gapInfo.max || v.price <= gapInfo.max);
              return ok ? v : Object.assign({}, v, { available: false });
            })
          });
          var pick = pickVariant(inWindow, contextColors);
          if (pick) return { product: p, pick: pick };
        }
        return null;
      })
      .catch(function () { return null; });
  }

  function hydrateCrossSell() {
    var slot = document.querySelector('[data-lm-cross-sell]');
    if (!slot || slot.dataset.lmDone) return;
    slot.dataset.lmDone = '1';
    var firstId = slot.dataset.firstProduct;
    if (!firstId) return;
    var inCart = (slot.dataset.cartProducts || '').split(',');
    var colors = (slot.dataset.cartColors || '').split('|').filter(Boolean);
    var gapInfo = readGap();
    function closesGap(x) { return !!gapInfo && x.pick.variant.price >= gapInfo.gap; }

    // Haengt der Aktionscode am Warenkorb, zeigen die Karten den Preis mit Rabatt (Marc 28.10.).
    var salePct = fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var hit = (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === SALE_CODE.code; });
        return hit && tierGiftsActive() ? SALE_CODE.pct : 0;
      })
      .catch(function () { return 0; });

    var picksReady = fetchRecommendations(firstId).then(function (products) {
      var noSets = (products || []).filter(function (p) { return !isSparsetProduct(p); });
      var picks = drawerPicks(noSets, colors, inCart);
      if (!gapInfo) return picks;
      var closers = picks.filter(closesGap);
      if (closers.length) return closers.concat(picks.filter(function (x) { return !closesGap(x); }));
      var taken = inCart.concat(picks.map(function (x) { return String(x.product.id); }));
      return fetchGapFiller(gapInfo, colors, taken).then(function (filler) {
        return filler ? [filler].concat(picks) : picks;
      });
    });
    Promise.all([picksReady, salePct]).then(function (res) {
      var picks = res[0], pct = res[1];
      var cards = picks.slice(0, 2).map(function (x) { // compact im Drawer
        return cardHtml(x.product, x.pick, true, closesGap(x) ? GAP_NOTE : null, pct);
      });
      if (!cards.length) return;
      slot.innerHTML =
        '<div style="border-top:1px solid rgba(var(--color-base-foreground),0.1);padding-top:12px;margin-top:2px;">' +
          '<div style="font-size:12px;font-weight:600;color:#666;margin-bottom:8px;">Passt perfekt dazu</div>' +
          '<div style="display:flex;flex-direction:column;gap:8px;">' + cards.join('') + '</div>' +
        '</div>';
    });
  }

  /* ---------------- PDP-Container ---------------- */

  var _compCache = {}; // productId -> products[] (Empfehlungen haengen am Produkt,
                       // nicht an der Variante; bei Farbwechsel nur neu rendern)

  function renderComplementary(slot, products) {
    var colors = slot.dataset.color ? [slot.dataset.color] : [];
    var limit = parseInt(slot.dataset.limit, 10) || 3;
    var cards = buildCards(products, colors, [String(slot.dataset.productId)], limit);
    if (!cards.length) { slot.innerHTML = ''; return; }
    var bg = slot.dataset.bg;
    slot.innerHTML =
      '<div style="' + (bg ? 'background:' + bg + ';border-radius:12px;padding:16px;' : '') + '">' +
        '<div class="heading text-base md:text-lg" style="margin-bottom:12px;">' + escapeHtml(slot.dataset.heading || 'Passt perfekt dazu') + '</div>' +
        '<div style="display:flex;flex-direction:column;gap:10px;">' + cards.join('') + '</div>' +
      '</div>';
  }

  function hydrateComplementary() {
    var slot = document.querySelector('[data-lm-complementary]');
    if (!slot) return;
    var productId = slot.dataset.productId;
    if (!productId) return;
    // Pro Farbe nur einmal rendern (verhindert Loop mit dem MutationObserver);
    // bei Farbwechsel setzt onVariantChange data-color neu -> laeuft erneut.
    if (slot.dataset.lmColorDone === (slot.dataset.color || '')) return;
    slot.dataset.lmColorDone = slot.dataset.color || '';

    if (_compCache[productId]) {
      renderComplementary(slot, _compCache[productId]);
    } else {
      fetchRecommendations(productId).then(function (products) {
        _compCache[productId] = products;
        renderComplementary(slot, products);
      });
    }
  }

  // Aktuell gewaehlte Farbe aus dem Varianten-Picker lesen.
  function currentPdpColor() {
    var group = document.querySelector('[data-option-group][data-option-name="farbe"]');
    if (!group) return null;
    var checked = group.querySelector('input[type="radio"]:checked');
    if (checked && checked.value) return checked.value;
    var label = group.querySelector('[data-option-group-selected-value-label]');
    return label ? label.textContent.trim() : null;
  }

  // Essence feuert variant:change auf document; Fallback: change im Farb-Fieldset.
  function onVariantChange() {
    var slot = document.querySelector('[data-lm-complementary]');
    if (!slot) return;
    var col = currentPdpColor();
    if (col != null && col !== slot.dataset.color) {
      slot.dataset.color = col; // hydrateComplementary rendert dann mit neuer Farbe
      hydrateComplementary();
    }
  }

  /* ---------------- Drawer-Refresh ---------------- */

  // #cart-drawer-maincontent existiert nur bei nicht-leerem Warenkorb
  // ({% if cart != empty %} in cart-modal.liquid). War der Warenkorb beim
  // Seitenaufbau leer, muss der komplette [slot=content] getauscht werden —
  // gleicher Fallback wie replaceCartDrawer() in der Section selbst.
  function swapDrawerHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('#cart-drawer-maincontent');
    var cur = document.querySelector('#cart-drawer-maincontent');
    if (next && cur) {
      cur.innerHTML = next.innerHTML; // Observer hydratisiert neu
      return;
    }
    var nextSlot = doc.querySelector('#cart-modal > div[slot="content"]');
    var curSlot = document.querySelector('#cart-modal > div[slot="content"]');
    if (nextSlot && curSlot) curSlot.innerHTML = nextSlot.innerHTML;
  }

  function replaceDrawer() {
    return fetch('/?section_id=cart-modal')
      .then(function (r) { return r.text(); })
      .then(swapDrawerHtml);
  }

  /* ---------------- Gutscheincode-Eingabe ---------------- */

  // Aktions-Codes mit Mindestmenge: bei Ablehnung erklaeren wir, warum der
  // Code (noch) nicht greift, statt der generischen Meldung. Neue Aktionscodes
  // hier ergaenzen (Codes GROSS schreiben).
  var CAMPAIGN_HINTS = [
    // Summer Sale 2026 (SUMMERPRESALE / SUMMERSALE / SOMMER, 20 % ab 2 Artikeln) beendet am 02.09.2026.
    // Beispiel fuer die naechste Aktion: { codes: ['CODE'], minQty: 2 },
    // Halloween 2026 (Code HALLOWEEN, 20 % ab 2 Produkten, bis 02.11.); die Function zaehlt
    // Wandsticker/Leuchtsterne/Geschenke nicht, dieser Hinweis ist nur die grobe Erklaerung.
    { codes: ['HALLOWEEN'], minQty: 2 },
  ];

  // Sparsets (Handle sparset-*/Set-Konfigurator bzw. _bundle_id-Property) und
  // Geschenkgutscheine sind von Aktionscodes ausgenommen und zaehlen nicht
  // zur Mindestmenge.
  function countsTowardCampaign(item) {
    if (item.gift_card || item.handle === 'lilimaus-geschenk-gutschein') return false;
    if (item.properties && item.properties._bundle_id) return false;
    if ((item.handle || '').indexOf('sparset-') === 0 || item.handle === 'erstelle-dein-set') return false;
    return true;
  }

  function eligibleQty(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return countsTowardCampaign(item) ? sum + item.quantity : sum;
    }, 0);
  }

  function voucherErrorMessage(code, cart) {
    var upper = code.toUpperCase();
    var campaign = CAMPAIGN_HINTS.find(function (c) { return c.codes.indexOf(upper) !== -1; });
    // Geschenkgutscheine laufen hier immer auf: /discount/ kennt nur Rabattcodes,
    // Shopify nimmt Gutscheine erst im Checkout an (Kundenfall 16.10.2026).
    if (!campaign) return 'Dieser Code ist ungültig oder für deinen Warenkorb nicht einlösbar. Ist es ein Geschenkgutschein? Den löst du im nächsten Schritt an der Kasse ein.';
    var qty = eligibleQty(cart);
    if (qty < campaign.minQty) {
      var missing = campaign.minQty - qty;
      var text = 'Der Code ' + upper + ' gilt ab ' + campaign.minQty + ' Artikeln im Warenkorb – leg noch '
        + (missing === 1 ? '1 Artikel' : missing + ' Artikel')
        + ' dazu, dann wird der Rabatt abgezogen.';
      if (qty < (cart.item_count || 0)) text += ' Sparsets & Geschenkgutscheine zählen dabei nicht mit.';
      return text;
    }
    // Mindestmenge erfuellt, trotzdem abgelehnt: Artikel sind nicht Teil der
    // Aktion (z.B. Sparsets/Gutscheine oder im Rabatt fehlende neue Produkte).
    return 'Der Code ' + upper + ' gilt leider nicht für die Artikel in deinem Warenkorb – Sparsets & Geschenkgutscheine sind von der Aktion ausgenommen.';
  }

  function applyVoucher(input, btn, msg) {
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = '…';
    msg.textContent = '';
    msg.style.color = '';
    // /discount/ setzt das Rabatt-Cookie und wendet den Code auf den Cart an
    // (Shopify Standard: genau 1 Code). redirect=/cart.js haelt die Antwort klein.
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var dc = (cart.discount_codes || []).find(function (d) {
          return (d.code || '').toLowerCase() === code.toLowerCase();
        });
        if (dc && dc.applicable) {
          // Erst evtl. Gratis-Geschenk einlegen (HBXFT5 & Co.), dann Drawer neu
          return syncGiftCodes(true).then(replaceDrawer); // grünes "Code angewendet"-Banner erscheint server-seitig
        }
        msg.textContent = voucherErrorMessage(code, cart);
        msg.style.color = '#b3261e';
        btn.disabled = false;
        btn.textContent = prev;
      })
      .catch(function () {
        msg.textContent = 'Etwas ist schiefgelaufen. Bitte versuch es erneut.';
        msg.style.color = '#b3261e';
        btn.disabled = false;
        btn.textContent = prev;
      });
  }

  /* ---------------- Gratis-Geschenk-Codes ---------------- */

  // Codes, die per Discount-Function "Gift Code Discount" ein Gratis-Geschenk
  // gewaehren (siehe Tools/Shopify-Gift-Code-Discount). Invariante: die
  // Geschenk-Line liegt nur im Warenkorb, solange der Code aktiv ist UND ein
  // Aktionsprodukt drin liegt — sonst raeumen wir sie wieder raus.
  // Numerische IDs (wie /cart.js sie liefert). Neue Codes hier ergaenzen.
  var GIFT_CODES = [
    {
      code: 'HBXFT5',
      productIds: [9928454504747],    // Wimpel- & Sternenkette Musselin
      giftVariantId: 50271841485099,  // 100 Leuchtsterne (7,99 €)
    },
  ];
  var GIFT_PROP = '_lm_gift_code';
  var giftSyncBusy = false;
  var giftSyncLast = 0;

  // Gleicht den Warenkorb mit den Gift-Codes ab. force=true umgeht die
  // Drossel (fuer den Moment direkt nach der Code-Eingabe). Gibt immer ein
  // Promise zurueck; ersetzt Drawer/Badge nur, wenn wirklich etwas geaendert wurde.
  function syncGiftCodes(force) {
    if (giftSyncBusy) return Promise.resolve();
    var now = Date.now();
    if (!force && now - giftSyncLast < 1500) return Promise.resolve();
    giftSyncLast = now;
    giftSyncBusy = true;
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var activeCodes = (cart.discount_codes || [])
          .filter(function (d) { return d.applicable; })
          .map(function (d) { return (d.code || '').toUpperCase(); });
        var items = cart.items || [];
        var jobs = [];
        GIFT_CODES.forEach(function (cfg) {
          var active = activeCodes.indexOf(cfg.code) !== -1;
          // Geschenk-Variante schon im Cart? (egal ob manuell oder auto)
          var giftLineAny = items.find(function (it) { return it.variant_id === cfg.giftVariantId; });
          // Von UNS eingelegte Line (Property-Marker) — nur die raeumen wir weg
          var giftLineAuto = items.find(function (it) {
            return it.properties && it.properties[GIFT_PROP] === cfg.code;
          });
          var hasEligible = items.some(function (it) {
            return cfg.productIds.indexOf(it.product_id) !== -1;
          });
          var want = active && hasEligible;
          if (want && !giftLineAny) {
            var props = {};
            props[GIFT_PROP] = cfg.code;
            jobs.push(fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: cfg.giftVariantId, quantity: 1, properties: props }),
            }));
          } else if (!want && giftLineAuto) {
            jobs.push(fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: giftLineAuto.key, quantity: 0 }),
            }));
          }
        });
        if (!jobs.length) return null;
        return Promise.all(jobs).then(function () {
          refreshCartBadge();
          return replaceDrawer();
        });
      })
      .catch(function () {})
      .then(function () { giftSyncBusy = false; });
  }

  /* ---------------- Schwellen-Geschenke (Halloween 2026) ---------------- */

  // Gratis-Geschenk ab Warenkorbwert. Den 0-€-Preis macht der automatische
  // Rabatt „Halloween-Geschenke“ (Function schwellen-geschenk-discount der
  // Bundle-App), hier wird nur eingelegt, rausgeraeumt und im Drawer erklaert.
  // Ab 50 € 100 Leuchtsterne, ab 100 € zusaetzlich eine Kette; ein Geschenk
  // zaehlt nie zu seiner eigenen Schwelle.
  // Leuchtsterne legen wir automatisch ein, die Kette waehlt die Kundin selbst
  // (Art + Farbe) ueber den Button im Hinweis.
  // Aktiv nur zwischen from und until. from: null = aus (Go-Live: Startzeit
  // eintragen, gleichzeitig Code + Geschenk-Rabatt aktivieren). In einem
  // unveroeffentlichten Theme (Vorschau) laeuft es zum Testen immer.
  var TIER_GIFTS = {
    from: '2026-10-28T17:30:00+01:00', // Start Marc 28.10.; HALLOWEEN 17:25 neu angelegt mit Bestellrabatt-Kombination (sonst faellt das Geschenk mit Code weg)
    until: '2026-11-02T23:59:00+01:00', // Sale bis einschl. Montag (Marc 28.10.)
    termsUrl: '/pages/aktionsbedingungen#halloween-2026', // Dauerseite, bleibt nach dem Sale (Marc 29.10.)
    small: { min: 5000, variantId: 50271841485099, label: '100 Leuchtsterne' },   // 7,99 € (Erhöhung am 28.10. zurückgenommen)
    // afterCode (Marc 29.10.): Kette erst ab 100 € nach Rabatt (SALE_CODE), wie big.afterCode der Function
    big: { min: 10000, productId: 9928454504747, url: '/products/wimpelkette', afterCode: true }, // Wimpel- & Sternenkette
  };
  // Aktionscode fuer die Preisanzeige in "Passt perfekt dazu" (gleiches Zeitfenster wie TIER_GIFTS)
  var SALE_CODE = { code: 'HALLOWEEN', pct: 20, minQty: 2,
    // zaehlen nicht zur Mindestmenge (wie notCountingProductIds/-VariantIds der Code-Config): Wandsticker,
    // von den Leuchtsternen nur das Geschenk 100-Leuchtsterne-gruen (Marc 30.10.)
    notCounting: [9962222780715], notCountingVariants: [50271841485099] };
  var TIER_PROP = '_lm_gift_tier';
  var tierBusy = false;
  var tierLast = 0;
  var tierHint = null; // { text, button } fuer den Drawer

  function tierGiftsActive() {
    var role = window.Shopify && Shopify.theme && Shopify.theme.role;
    if (role && role !== 'main') return true;
    var now = Date.now();
    if (!TIER_GIFTS.from || now < Date.parse(TIER_GIFTS.from)) return false;
    return now <= Date.parse(TIER_GIFTS.until);
  }

  // Kontingent (Marc 28.10.): nur die ersten 100 Bestellungen bekommen ein Geschenk.
  // Tools/Shopify-Halloween-Geschenkzaehler schreibt den Rest jede Minute ins Shop-Metafeld,
  // sections/lm-geschenke-rest.liquid gibt ihn aus (Zeitstempel umgeht den Seiten-Cache).
  // Seit 30.10. (Linus): Der Rest zaehlt nur noch Gratis-Ketten. Rest 0: keine Gratis-Kette mehr
  // (der Zaehler nimmt sie nach 20 Min Nachlauf aus dem Rabatt), die Leuchtsterne bleiben.
  // Unbekannt (null): weiter wie bisher.
  var tierRest = null;
  var tierRestAt = 0;
  function fetchTierRest() {
    if (Date.now() - tierRestAt < 30000) return Promise.resolve(tierRest);
    return fetch('/?section_id=lm-geschenke-rest&t=' + Date.now())
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = /data-lm-geschenke-rest="(-?\d+)"/.exec(html);
        // Eine einmal gesehene 0 bleibt 0 (Prüfer H1): sonst legte ein Fehlabruf die
        // Sterne wieder ein, die nach dem Abschalten 7,99 € kosten.
        if (m) tierRest = parseInt(m[1], 10);
        else if (tierRest !== 0) tierRest = null;
        tierRestAt = Date.now();
        return tierRest;
      })
      .catch(function () { return tierRest; });
  }

  // Rechnet wie die Functions schwellen-geschenk-discount und aktions-code-discount
  // (Bundle-App), in Cent: Summe aller Lines (Originalpreis, ohne Gutscheine und ohne
  // 0-€-Geschenke anderer Aktionen) abzueglich der Geschenk-Einheiten selbst.
  //   basisBig   = Summe - ein LS-Geschenk - eine Kette
  //   basisSmall = Summe - ein LS-Geschenk - (Kette, falls sie gratis ist)
  // Kette nach Rabatt (big.afterCode, Marc 29.10.): Haengt SALE_CODE am Warenkorb und
  // greift er auch mit der Kette als Geschenk (Mindestmenge ohne Kette), zaehlt basisBig
  // abzueglich des Code-Prozentsatzes (Sparsets nimmt der Code aus). counting = zaehlende
  // Produkte wie in aktions-code-discount, ketteCounts = davon die Kette (falls drin).
  // gapBig = Warenwert (voller Preis), der bis zur Gratis-Kette fehlt. Haengt der Code am
  // Warenkorb, rechnet er so, als griffe der Code schon: Das naechste Produkt schaltet ihn
  // meist ein, dann zaehlen nur 80 % davon (Prüfer 29.10. B1).
  function tierState(items, cart) {
    var total = 0;
    var smallPrice = null;
    var bigPrice = null;
    var counting = 0;
    var bundleCents = 0;
    items.forEach(function (it) {
      if (it.gift_card) return;
      var p = it.properties || {};
      // 0-€-Geschenke anderer Aktionen zaehlen nicht (wie in beiden Functions).
      if (p._bundle_gift || p._lm_gift_code) return;
      total += it.original_line_price;
      if (p._bundle_id) bundleCents += it.original_line_price;
      else if (!p[TIER_PROP] && SALE_CODE.notCounting.indexOf(it.product_id) === -1
        && SALE_CODE.notCountingVariants.indexOf(it.variant_id) === -1) counting += it.quantity;
      if (it.variant_id === TIER_GIFTS.small.variantId && (smallPrice === null || it.original_price < smallPrice)) smallPrice = it.original_price;
      if (it.product_id === TIER_GIFTS.big.productId && (bigPrice === null || it.original_price < bigPrice)) bigPrice = it.original_price;
    });
    var ketteCounts = bigPrice !== null && SALE_CODE.notCounting.indexOf(TIER_GIFTS.big.productId) === -1 ? 1 : 0;
    var basisBig = total - (smallPrice || 0) - (bigPrice || 0);
    var hasCode = !!cart && (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === SALE_CODE.code; });
    var codeOn = !!TIER_GIFTS.big.afterCode && hasCode && SALE_CODE.pct < 100;
    var basisCode = basisBig - Math.round((basisBig - bundleCents) * SALE_CODE.pct / 100);
    var afterCode = codeOn && counting - ketteCounts >= SALE_CODE.minQty;
    if (afterCode) basisBig = basisCode;
    var kettenAus = tierRest !== null && tierRest <= 0;
    var bigFree = !kettenAus && bigPrice !== null && basisBig >= TIER_GIFTS.big.min;
    var basisSmall = total - (smallPrice || 0) - (bigFree ? bigPrice : 0);
    var gapBig = codeOn
      ? Math.max(0, Math.ceil((TIER_GIFTS.big.min - basisCode) * 100 / (100 - SALE_CODE.pct)))
      : Math.max(0, TIER_GIFTS.big.min - basisBig);
    return { basisBig: basisBig, basisSmall: basisSmall, hasBig: bigPrice !== null, bigFree: bigFree,
      afterCode: codeOn, gapBig: gapBig, countingAll: counting, counting: counting - (bigFree ? ketteCounts : 0) };
  }

  // Ein Code, der den Geschenk-Rabatt verdraengt (z. B. COZY15: nicht mit Bestellrabatten
  // kombinierbar, 28.10.), laesst die eingelegten Sterne 7,99 € kosten. Erkennbar daran, dass
  // die Auto-Sterne nicht um einen vollen Stueckpreis reduziert sind: dann raus damit und erst
  // wieder einlegen, wenn sich Codes oder Warenkorbwert aendern (sonst Endlosschleife).
  // Die Sperre ueberlebt Seitenwechsel (sessionStorage), sonst legte jede Seite neu ein.
  var TIER_BLOCK_STORE = 'lm_tier_gift_blocked';
  var tierBlockedKey = null;
  try { tierBlockedKey = sessionStorage.getItem(TIER_BLOCK_STORE); } catch (e) {}
  function setTierBlocked(key) {
    tierBlockedKey = key;
    try {
      if (key === null) sessionStorage.removeItem(TIER_BLOCK_STORE);
      else sessionStorage.setItem(TIER_BLOCK_STORE, key);
    } catch (e) {}
  }
  function tierCodes(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable; })
      .map(function (d) { return String(d.code).toUpperCase(); }).sort();
  }
  function tierGiftLost(line) {
    return !!line && line.original_price > 0
      && line.original_line_price - line.final_line_price < line.original_price;
  }
  function tierBlockedHint(codes) {
    return codes.length ? { text: 'Das Gratis-Geschenk gibt es leider nicht zusammen mit dem Code ' + codes.join(', ') + '.'
      + (codes.indexOf('HALLOWEEN') < 0 ? ' Mit HALLOWEEN bekommst du 20 % ab 2 Produkten und das Geschenk.' : '') } : null;
  }

  // Code haengt am Warenkorb, greift aber erst ab minQty zaehlenden Produkten (Function
  // aktions-code-discount: ohne Geschenke, Sets, Gutscheine, notCounting). Dann fehlt am
  // Produkt jeder Rabatt; der Hinweis sagt, was noch fehlt (Marc 28.10.).
  function saleCodeTip(cart) {
    var has = (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === SALE_CODE.code; });
    if (!has) return '';
    // Eine Gratis-Kette ist kein zweites Produkt (wie in der Function), tierState zieht sie ab.
    // Rest 0: Der Zaehler leert giftTiers in der Code-Config, dann zaehlt die Kette wieder (Prüfer H1).
    var st = tierState(cart.items || [], cart);
    var missing = SALE_CODE.minQty - (tierRest !== null && tierRest <= 0 ? st.countingAll : st.counting);
    if (missing <= 0) return '';
    return 'Leg noch ' + (missing === 1 ? '1 Produkt' : missing + ' Produkte') + ' dazu, dann gibt\u2019s mit ' + SALE_CODE.code + ' ' + SALE_CODE.pct + ' % Rabatt.';
  }
  function withCodeTip(hint, cart) {
    var tip = saleCodeTip(cart);
    if (!tip) return hint;
    return { text: tip + (hint ? ' ' + hint.text : ''), button: hint && hint.button };
  }

  function syncTierGifts(force) {
    if (!tierGiftsActive()) { tierHint = null; return Promise.resolve(); }
    if (tierBusy) return Promise.resolve();
    var now = Date.now();
    if (!force && now - tierLast < 1500) return Promise.resolve();
    tierLast = now;
    tierBusy = true;
    var rest = null;
    return fetchTierRest()
      .then(function (r) { rest = r; return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) { tierHint = null; renderTierHint(); return null; }
        var isSmall = function (it) { return it.variant_id === TIER_GIFTS.small.variantId; };
        var smallAny = items.find(isSmall);
        var smallAuto = items.find(function (it) { return it.properties && it.properties[TIER_PROP]; });
        var st = tierState(items, cart);

        var kettenAus = rest !== null && rest <= 0;
        // Seit 28.10. (Ansage Linus): ab 100 € Leuchtsterne UND Kette, die Sterne bleiben drin.
        var wantSmall = st.basisSmall >= TIER_GIFTS.small.min;
        var codes = tierCodes(cart);
        var key = codes.join(',') + '|' + st.basisSmall;
        if (tierBlockedKey !== null && tierBlockedKey !== key) setTierBlocked(null);
        var giftLost = tierGiftLost(smallAuto);
        if (giftLost) setTierBlocked(key);
        var blocked = tierBlockedKey !== null;

        if (blocked && wantSmall) {
          tierHint = tierBlockedHint(codes);
        } else if (st.bigFree) {
          tierHint = { text: TIER_GIFTS.small.label + ' und deine Kette sind ein Geschenk von uns.' };
        } else if (kettenAus && wantSmall) {
          tierHint = { text: TIER_GIFTS.small.label + ' sind gratis dabei. Die Gratis-Ketten sind leider schon alle vergeben.' };
        } else if (st.basisBig >= TIER_GIFTS.big.min) {
          tierHint = { text: TIER_GIFTS.small.label + ' sind gratis dabei, und du bekommst zusätzlich eine Wimpel- oder Sternenkette geschenkt.', button: 'Such dir deine Gratis-Kette aus' };
        } else if (wantSmall) {
          tierHint = { text: TIER_GIFTS.small.label + ' sind gratis dabei. Noch ' + money(st.gapBig) + ' bis zur Gratis-Kette'
            + (st.afterCode ? ' (ab 100 € nach Rabatt).' : '.') };
        } else {
          tierHint = { text: 'Noch ' + money(TIER_GIFTS.small.min - st.basisSmall) + ' bis zu deinen Gratis-Leuchtsternen.' };
        }
        tierHint = withCodeTip(tierHint, cart);
        renderTierHint();

        if (giftLost) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: smallAuto.key, quantity: 0 }),
          }).then(function () { refreshCartBadge(); return replaceDrawer(); });
        }
        if (wantSmall && !smallAny && !blocked) {
          var props = {};
          props[TIER_PROP] = 'halloween';
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: TIER_GIFTS.small.variantId, quantity: 1, properties: props }),
          })
            // Gleich nachsehen, ob die Sterne wirklich 0 € kosten; sonst sofort wieder raus.
            .then(function () { return fetch('/cart.js'); })
            .then(function (r) { return r.json(); })
            .then(function (c2) {
              var added = (c2.items || []).find(function (it) { return it.properties && it.properties[TIER_PROP]; });
              if (!tierGiftLost(added)) return null;
              setTierBlocked(key);
              tierHint = tierBlockedHint(codes);
              renderTierHint();
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: added.key, quantity: 0 }),
              });
            })
            .then(function () { refreshCartBadge(); return replaceDrawer(); });
        }
        if (!wantSmall && smallAuto) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: smallAuto.key, quantity: 0 }),
          }).then(function () { refreshCartBadge(); return replaceDrawer(); });
        }
        return null;
      })
      .catch(function () {})
      .then(function () { tierBusy = false; });
  }

  // Hinweis unter der Versandkosten-Leiste. Idempotent, weil jeder Drawer-Swap
  // den Observer ausloest und hydrate() hier erneut vorbeikommt.
  function renderTierHint() {
    var header = document.querySelector('#cart-drawer-maincontent .modal-header');
    var el = document.querySelector('[data-lm-tier-hint]');
    // Platz fuer "Passt perfekt dazu" (Marc 28.10.): der Hinweis steht als schlichte Zeile in
    // der Versandanzeige und ersetzt "Geschafft: ..." (Gratisversand steht unten nochmal).
    var ship = header && header.querySelector('.free-shipping-indicator');
    var shipText = ship && ship.firstElementChild;
    var shipDone = !!shipText && /Geschafft/.test(shipText.textContent);
    if (!tierHint || !header || !document.querySelector('#DrawerCartList')) {
      if (el) el.remove();
      if (shipText) shipText.style.display = '';
      return;
    }
    if (shipText) shipText.style.display = shipDone ? 'none' : '';
    var html = '<span>' + escapeHtml(tierHint.text) + '</span>'
      + (tierHint.button ? ' <a href="' + TIER_GIFTS.big.url + '" style="font-weight:700;color:inherit;text-decoration:underline;white-space:nowrap;">' + escapeHtml(tierHint.button) + ' &rarr;</a>' : '')
      // Aktionsbedingungen (inkl. Teilretouren-Klausel) direkt vor dem Kauf verlinken (Marc 29.10.)
      + ' <a href="' + TIER_GIFTS.termsUrl + '" style="color:inherit;text-decoration:underline;white-space:nowrap;opacity:.75;">Aktionsbedingungen</a>';
    // Vergleich ueber ein eigenes Attribut: innerHTML kommt vom Browser
    // normalisiert zurueck (style-Schreibweise) und waere nie gleich -> Endlosschleife.
    if (el && el.getAttribute('data-lm-tier-hint') === html) return;
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-lm-tier-hint', '');
      el.setAttribute('role', 'status');
      if (ship && shipText) {
        el.style.cssText = 'margin-top:' + (shipDone ? '0' : '4px') + ';line-height:1.4;';
        ship.insertBefore(el, shipText.nextSibling);
      } else {
        el.style.cssText = 'margin-top:10px;padding:10px 12px;border-radius:8px;background:#fdf6f0;border:1px solid #ecd9c8;font-size:12.5px;line-height:1.4;color:#2c2c2c;';
        header.appendChild(el);
      }
    }
    el.setAttribute('data-lm-tier-hint', html);
    el.innerHTML = html;
  }

  /* ---------------- Warenkorb-Add ---------------- */

  function refreshCartBadge() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var b = document.getElementById('CartBubble');
        if (!b) return;
        b.textContent = c.item_count;
        if (c.item_count > 0) b.classList.remove('hidden');
      })
      .catch(function () {});
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    var prev = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch('/?section_id=cart-modal');
      })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        swapDrawerHtml(html);
        btn.textContent = '✓';
        btn.disabled = false;
        refreshCartBadge();
        setTimeout(function () { btn.textContent = prev; }, 2500);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = prev;
      });
  }

  /* ---------------- Wiring ---------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-lm-add]');
    if (btn) {
      e.preventDefault();
      addToCart(btn.getAttribute('data-lm-add'), btn);
      return;
    }
    var voucherBtn = e.target.closest && e.target.closest('[data-lm-voucher-apply]');
    if (voucherBtn) {
      e.preventDefault();
      var box = voucherBtn.closest('[data-lm-voucher]');
      applyVoucher(box.querySelector('[data-lm-voucher-input]'), voucherBtn, box.querySelector('[data-lm-voucher-msg]'));
    }
  });

  // Enter im Gutscheinfeld = Einlösen (nicht das Cart-Formular absenden)
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-lm-voucher-input]');
    if (!input) return;
    e.preventDefault();
    var box = input.closest('[data-lm-voucher]');
    applyVoucher(input, box.querySelector('[data-lm-voucher-apply]'), box.querySelector('[data-lm-voucher-msg]'));
  });

  // PDP-Empfehlung dem Variantenwechsel folgen lassen (Essence ersetzt den
  // Container nicht selbst -> wir lauschen aktiv auf die Farbwahl).
  document.addEventListener('variant:change', onVariantChange);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-option-group][data-option-name="farbe"]')) {
      setTimeout(onVariantChange, 60);
    }
  }, true);

  var scheduled = null;
  function hydrate() {
    hydrateCrossSell();
    hydrateComplementary();
    // Cart hat sich evtl. geaendert (Drawer-Replace loest den Observer aus):
    // Gift-Codes nachziehen. Gedrosselt; ohne Handlungsbedarf nur 1 GET /cart.js.
    syncGiftCodes(false);
    renderTierHint();
    syncTierGifts(false);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = requestAnimationFrame(function () {
      scheduled = null;
      hydrate();
    });
  }

  function init() {
    hydrate();
    // Drawer UND PDP-Section werden per innerHTML ersetzt (Cart-Update,
    // Variantenwechsel-Morph) -> frische Container erkennen und fuellen.
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
